module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./AggregateLinkView.js"));
	}, "AggregateLinkView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=AggregateLinkView!./src/pages/Shop/Home/AggregateLink/AggregateLinkView.js
// module id = 1410
// module chunks = 418